const PropTypes = require('prop-types');
/**
 * Created by adderlyjaureguicampos on 06/12/16.
 */
const React = require('react');

const { formatText } = require('core/i18n').i18n;
const { OKCheckbox } = require('commonsComponents/OKCheckbox');
const OKSelect = require('components/commons/OKSelect/OKSelect');

class InvestmentTaxForm extends React.Component {

    constructor(props) {
        super(props);

        let initialState;
        if (this.props.values) {
            initialState = this.props.values
        } else {
            initialState = {
                firstCheckboxGroupOption_1: false,
                firstCheckboxGroupOption_2: false,
                firstCheckboxGroupOption_3: false,
                firstCheckboxGroupOption_4: false,
                firstCheckboxGroupOption_5: false,
                firstCheckboxGroupOption_6: false,
                secondCheckboxGroupOption_1: false,
                secondCheckboxGroupOption_2: false,
                secondCheckboxGroupOption_3: false,
                secondCheckboxGroupOption_4: false,
                secondCheckboxGroupOption_5: false,
                secondCheckboxGroupOption_6: false,
                thirdCheckboxGroupOption_1: false,
                thirdCheckboxGroupOption_2: false,
                thirdCheckboxGroupOption_3: false,
                thirdCheckboxGroupOption_4: false,
                thirdCheckboxGroupOption_5: false,
                thirdCheckboxGroupOption_6: false,
                annualIncomeSelect: ''
            };
        }
        this.state = initialState;
        this.buildFirstCheckboxOptions = this.buildFirstCheckboxOptions.bind(this);
        this.buildSecondCheckboxOptions = this.buildSecondCheckboxOptions.bind(this);
        this.buildThirdCheckboxOptions = this.buildThirdCheckboxOptions.bind(this);
        this.buildAnnualIncomeSelect = this.buildAnnualIncomeSelect.bind(this);
        this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
        this.handleChange = this.handleChange.bind(this);


    }

    buildAnnualIncomeSelect() {
        const selectOptions = [
            {
                value: 1,
                label: formatText('contractsView-checkingAccountInvestmentAnnualIncomeOption_1')
            },
            {
                value: 2,
                label: formatText('contractsView-checkingAccountInvestmentAnnualIncomeOption_2')
            },
            {
                value: 3,
                label: formatText('contractsView-checkingAccountInvestmentAnnualIncomeOption_3')
            },
            {
                value: 4,
                label: formatText('contractsView-checkingAccountInvestmentAnnualIncomeOption_4')
            }
        ];
        return (
            <OKSelect
                placeholder={formatText('contractsView-checkingAccountInvestmentAnnualIncomePlaceholder')}
                searchable={true}
                options={selectOptions}
                onChange={this.handleChange}
                value={this.state.annualIncomeSelect}
            />
        );
    }

    buildFirstCheckboxOptions() {
        let firstCheckboxGroup = [];
        const firstCheckboxGroupOptions = [
            {
                value: this.state.firstCheckboxGroupOption_1,
                label: formatText('contractsView-checkingAccountInvestmentFirstCheckGroupOption_1')
            },
            {
                value: this.state.firstCheckboxGroupOption_2,
                label: formatText('contractsView-checkingAccountInvestmentFirstCheckGroupOption_2')
            },
            {
                value: this.state.firstCheckboxGroupOption_3,
                label: formatText('contractsView-checkingAccountInvestmentFirstCheckGroupOption_3')
            },
            {
                value: this.state.firstCheckboxGroupOption_4,
                label: formatText('contractsView-checkingAccountInvestmentFirstCheckGroupOption_4')
            },
            {
                value: this.state.firstCheckboxGroupOption_5,
                label: formatText('contractsView-checkingAccountInvestmentFirstCheckGroupOption_5')
            },
            {
                value: this.state.firstCheckboxGroupOption_6,
                label: formatText('contractsView-checkingAccountInvestmentFirstCheckGroupOption_6')
            }
        ];
        firstCheckboxGroupOptions.forEach((option, index) => {
            const name = 'firstCheckboxGroupOption_' + (index + 1);
            firstCheckboxGroup.push(
                <div>
                    <OKCheckbox
                        key={index}
                        idName={name}
                        label={option.label}
                        value={option.value}
                        onChange={this.handleCheckboxChange}/>
                </div>
            )
        });

        return firstCheckboxGroup;
    }

    buildSecondCheckboxOptions() {
        let secondCheckboxGroup = [];
        const secondCheckboxGroupOptions = [
            {
                value: this.state.secondCheckboxGroupOption_1,
                label: formatText('contractsView-checkingAccountInvestmentSecondCheckGroupOption_1')
            },
            {
                value: this.state.secondCheckboxGroupOption_2,
                label: formatText('contractsView-checkingAccountInvestmentSecondCheckGroupOption_2')
            },
            {
                value: this.state.secondCheckboxGroupOption_3,
                label: formatText('contractsView-checkingAccountInvestmentSecondCheckGroupOption_3')
            },
            {
                value: this.state.secondCheckboxGroupOption_4,
                label: formatText('contractsView-checkingAccountInvestmentSecondCheckGroupOption_4')
            },
            {
                value: this.state.secondCheckboxGroupOption_5,
                label: formatText('contractsView-checkingAccountInvestmentSecondCheckGroupOption_5')
            },
            {
                value: this.state.secondCheckboxGroupOption_6,
                label: formatText('contractsView-checkingAccountInvestmentSecondCheckGroupOption_6')
            }
        ];
        secondCheckboxGroupOptions.forEach((option, index) => {
            const name = 'secondCheckboxGroupOption_' + (index + 1);
            secondCheckboxGroup.push(
                <div>
                    <OKCheckbox
                        key={index}
                        idName={name}
                        label={option.label}
                        value={option.value}
                        onChange={this.handleCheckboxChange}/>
                </div>
            )
        });
        return secondCheckboxGroup;
    }

    buildThirdCheckboxOptions() {
        let thirdCheckboxGroup = [];
        const thirdCheckboxGroupOptions = [
            {
                value: this.state.thirdCheckboxGroupOption_1,
                label: formatText('contractsView-checkingAccountInvestmentThirdCheckGroupOption_1')
            },
            {
                value: this.state.thirdCheckboxGroupOption_2,
                label: formatText('contractsView-checkingAccountInvestmentThirdCheckGroupOption_2')
            },
            {
                value: this.state.thirdCheckboxGroupOption_3,
                label: formatText('contractsView-checkingAccountInvestmentThirdCheckGroupOption_3')
            },
            {
                value: this.state.thirdCheckboxGroupOption_4,
                label: formatText('contractsView-checkingAccountInvestmentThirdCheckGroupOption_4')
            },
            {
                value: this.state.thirdCheckboxGroupOption_5,
                label: formatText('contractsView-checkingAccountInvestmentThirdCheckGroupOption_5')
            },
            {
                value: this.state.thirdCheckboxGroupOption_6,
                label: formatText('contractsView-checkingAccountInvestmentThirdCheckGroupOption_6')
            }
        ];
        thirdCheckboxGroupOptions.forEach((option, index) => {
            const name = 'thirdCheckboxGroupOption_' + (index + 1);
            thirdCheckboxGroup.push(
                <div>
                    <OKCheckbox
                        key={index}
                        idName={name}
                        label={option.label}
                        value={option.value}
                        onChange={this.handleCheckboxChange}/>
                </div>
            )
        });
        return thirdCheckboxGroup;
    }

    handleChange(event) {
        this.setState({annualIncomeSelect: Number(event.value)});
    }

    handleCheckboxChange(event) {
        this.setState({ [event.target.id] : event.target.checked});
    }

    render() {

        let firstCheckboxGroup = this.buildFirstCheckboxOptions();
        let secondCheckboxGroup = this.buildSecondCheckboxOptions();
        let thirdCheckboxGroup = this.buildThirdCheckboxOptions();
        let annualIncomeSelect = this.buildAnnualIncomeSelect();
        this.props.dataReceiver(this.state);
        return (
            <div>
                <div >
                    <div className="autonomous-tax-form__form-title">{formatText('contractsView-checkingAccountInvestmentFirstCheckGroupTitle')}</div>
                    {firstCheckboxGroup}
                </div>
                <div >
                    <div className="autonomous-tax-form__form-title">{formatText('contractsView-checkingAccountInvestmentSecondCheckGroupTitle')}</div>
                    {secondCheckboxGroup}
                </div>
                <div >
                    <div className="autonomous-tax-form__form-title">{formatText('contractsView-checkingAccountInvestmentThirdCheckGroupTitle')}</div>
                    {thirdCheckboxGroup}
                </div>
                <div className="tax-data__element-form-select">
                    <div className="autonomous-tax-form__form-title">{formatText('contractsView-checkingAccountInvestmentFourthCheckGroupTitle')}</div>
                    {annualIncomeSelect}
                </div>
            </div>
        )
    }

}
InvestmentTaxForm.propTypes = {
    dataReceiver: PropTypes.func,
    values: PropTypes.object
};

module.exports = InvestmentTaxForm;
